const baseUrl = `/diagnostic-imaging`;

export const labResultIdParamName = 'labResultId';
export const labResultIdParam = `:${labResultIdParamName}`;

export const ROUTES = {
    LIST: `${baseUrl}`,
    DETAILS: `${baseUrl}/${labResultIdParam}/details`
};
